/*
 * cmn.js
 */

// import jQuery from 'jquery';  //node_modlesの中にあるものを使用探しに行ってくれる
import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel';
import {gsap} from "gsap";
import '../scss/style.scss';

// /* FIX Viewport
// ------------------------------*/
!(function () {
	const viewport = document.querySelector('meta[name="viewport"]');
	function switchViewport() {
		const value =
			window.outerWidth > 360
				? 'width=device-width,initial-scale=1'
				: 'width=360';
		if (viewport.getAttribute('content') !== value) {
			viewport.setAttribute('content', value);
		}
	}
	addEventListener('resize', switchViewport, false);
	switchViewport();
})();

// /* Check Android 
// ----------------------------------*/
const getMobileOS = () => {
	const ua = navigator.userAgent
	if (/android/i.test(ua)) {
		return "Android"
	}
}


$(function(){
/* ==========================================================
!stack
========================================================== */
/* 関数の読み込み
------------------------------------ */
	toggleMenu();
	openModalMenu();
	closeModalMenu();
	pageTop();
	pageTopFixed();
	pageScroll();
	Accordion();
	tabMenu();
	scrollAnimation();
	telLink();

/* スライダー系処理
-------------------------------------------------- */
	$('.js-carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "15%",
					dots: true,
				}
			}
		]
	});

	// $('.js-slide01').slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	fade: true,
	// 	asNavFor: '.js-slide01-tumbs'
	// });
	// $('.js-slide01-tumbs').slick({
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	asNavFor: '.js-slide01',
	// 	dots: false,
	// 	arrows: true,
	// 	focusOnSelect: true,
	// 	responsive: [
	// 		{
	// 			breakpoint: 768,
	// 			settings: {
	// 				slidesToShow: 3,
	// 				variableWidth: true,
	// 			}
	// 		}
	// 	]
	// });

	// $('.js-fade-slider01').slick({
	// 	autoplay: true,
	// 	speed: 3000,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	fade: true,
	// });

	// $('.js-midslider').slick({
	// 	autoplay: true,
	// 	autoplaySpeed: 0,
	// 	speed: 20000,
	// 	cssEase: "linear",
	// 	slidesToShow: 1.8,
	// 	swipe: false,
	// 	arrows: false,
	// 	pauseOnFocus: false,
	// 	pauseOnHover: false,
	// 	responsive: [
	// 		{
	// 			breakpoint: 768,
	// 			settings: {
	// 				slidesToShow: 0.7,
	// 			}
	// 		}
	// 	]
	// });

/* フォームファイル処理
-------------------------------------------------- */

	$('.attachment .fileinput').on('change', function () {
	 var file = $(this).prop('files')[0];
		 $(this).closest('.attachment').find('.filename').text(file.name);
	});

/* フォームプライバシー処理
-------------------------------------------------- */

	var privacy = $('.privacyInput');
	var sendbutton = $('.submitBtn');

	if (privacy.length > 0) {
		sendbutton.prop("disabled", true).addClass('disabled');
		
		if (privacy.is(':checked')) {
			// ボタンを有効化
			sendbutton.prop('disabled', false).removeClass('disabled');
		} else {
			// ボタンを無効化
			sendbutton.prop("disabled", true).addClass('disabled');
		}
		
		privacy.change(function() {
			if (privacy.is(':checked')) {
				// ボタンを有効化
				sendbutton.prop('disabled', false).removeClass('disabled');
			} else {
				// ボタンを無効化
				sendbutton.prop("disabled", true).addClass('disabled');
			}
		});
	}

});



/* アンカー付きページ移動処理
-------------------------------------------------- */
$(window).on("load", function () {
	const hash = location.hash; //ハッシュを取得
	console.log(hash);
	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:767px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの
		if($(hash).length) {
			$("html, body").animate({
				scrollTop: $(hash).offset().top - 80,
			},500);
		}

	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの
		if($(hash).length) {
			$("html, body").animate({
				scrollTop: $(hash).offset().top - 120,
			},500);
		}

	}
});

// /* グロナビ処理
// -------------------------------------------------- */

// /* グローバル */
const pointSPHeader = window.matchMedia('screen and (max-width: 959px)');
let beforePos = 0;

/* toggleMenu
-------------------------------------------------- */
const toggleMenu = function(){
	const $toggleBtn = $('.l-menu-trigger');
	const $toggleMenu = $('#' + $toggleBtn.attr('aria-controls'));
	const $body = $('body');
	let w = $(window).width();
	let scrollpos = 0;

	$toggleBtn.on('click',function(){
		let expanded = $(this).attr('aria-expanded');
		// console.log(expanded);
		if(expanded == 'false') {
			openMenu();
		}else {
			closeMenu();
		}
	});

	function openMenu() {
		scrollpos = $(window).scrollTop();
		// console.log(scrollpos);
		$toggleMenu.attr('aria-hidden','false').fadeIn();
		$toggleBtn.attr('aria-expanded','true');
		$body.addClass('nav-open').css({"top": -scrollpos});
		
	}
	function closeMenu() {
		$toggleMenu.attr('aria-hidden','true').fadeOut();
		$toggleBtn.attr('aria-expanded','false');
		$body.removeClass('nav-open').css({"top": 0});
		$('html, body').animate({scrollTop:scrollpos},0);
	}
	function resetMenu() {
		$toggleBtn.attr('aria-expanded','false');
		$body.removeClass('nav-open').css({"top": 0});
		$('html, body').animate({scrollTop:scrollpos},0);
		// $toggleMenu.attr('aria-hidden','true').hide();
		$toggleMenu.removeAttr('aria-hidden').show();
	}

	function checkBreakPoint() {
		if (!pointSPHeader.matches) {
			resetMenu();
		}else {
			closeMenu();
		}
	}
	if(w < 945){
		closeMenu();
	}

	pointSPHeader.addListener(checkBreakPoint);
}

/* openModalMenu /closeModalMenu
-------------------------------------------------- */
const openModalMenu = function(){
	const $modalOverlay = $('#overlay');
	const $openModalBtn = $(".js-modalMenuBtn");

	$openModalBtn.on('click',function(){
		const targetID = '#' + $(this).attr('aria-controls');
		$modalOverlay.fadeIn();
		$(this).attr('aria-expanded','true');
		$(targetID).fadeIn().attr('aria-hidden','false');
	});
}
const closeModalMenu = function() {
	const $modalOverlay = $('#overlay');
	const $modal = $(".l-gnavi-modal");
	const $openModalBtn = $(".js-modalMenuBtn");
	const $closeModalBtn = $(".js-closeModalBtn");

	function closeModal() {
		$modalOverlay.fadeOut();
		$modal.fadeOut().attr('aria-hidden','true');
		$openModalBtn.attr('aria-expanded','false');
	}

	$modalOverlay.on('click',function(){
		closeModal();
	});
	$closeModalBtn.on('click',function(){
		closeModal();
	});
}


/* ==========================================================
!pageTop
========================================================== */
const pageTop = function () {
	$(".pagetop").click(function () {
		$("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutCubic");
		return false;
	});
};
/* ==========================================================
!fixed pagetop scroll
========================================================== */
const pageTopFixed = function () {
	const pageTopBox = $(".l-pagetop--fixed");
	const pageTopLink = $(".c-btn-pagetop");

	pageTopBox.hide();
	$(window).on('scroll',function () {
		if ($(this).scrollTop() > 200) {
			pageTopBox.fadeIn();
		} else {
			pageTopBox.fadeOut();
		}

		var scrollHeight = $(document).height();
		var scrollPosition = $(window).height() + $(window).scrollTop();

		/* window.matchMedia
		------------------------------------ */
		if(window.matchMedia("(max-width:767px)").matches){
			// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの
			
			var footHeight = $(".l-footer-copyright").innerHeight();
			if ( scrollHeight - scrollPosition  <= footHeight ) {
				pageTopLink.css({"position":"absolute","bottom": "50px"});
			} else {
				pageTopLink.css({"position":"fixed","bottom": "20px"});
			}


		}else{
			// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの

			var footHeight = $(".l-footer-brand").innerHeight() + $(".l-footer-copyright").innerHeight();
			if ( scrollHeight - scrollPosition  <= footHeight ) {
				pageTopLink.css({"position":"fixed","bottom": "500px"});
			} else {
				pageTopLink.css({"position":"fixed","bottom": "20px"});
			}

		}

		function matchFunction(){
			// (3)windowサイズを変更して、767px以下になったら発火するイベント

			var footHeight = $(".l-footer-copyright").innerHeight();
			if ( scrollHeight - scrollPosition  <= footHeight ) {
				pageTopLink.css({"position":"absolute","bottom": "50px"});
			} else {
				pageTopLink.css({"position":"fixed","bottom": "20px"});
			}

			if(window.matchMedia("(min-width:768px)").matches){
				// (4)windowサイズを変更して、768px以上になったら発火するイベント

				var footHeight = $(".l-footer-brand").innerHeight() + $(".l-footer-copyright").innerHeight();
				if ( scrollHeight - scrollPosition  <= footHeight ) {
					pageTopLink.css({"position":"fixed","bottom": "500px"});
				} else {
					pageTopLink.css({"position":"fixed","bottom": "20px"});
				}

			}
		}
		window.matchMedia("(max-width:767px)").addListener(matchFunction);

	});

	pageTopBox.on('click',function () {
	$('body,html').animate({
		scrollTop: 0
	}, 500);
	return false;
	});

};
/* ==========================================================
!pageScroll
========================================================== */
const pageScroll = function () {
	// jQuery.easing.easeInOutCubic = function (x, t, b, c, d) {
	// 	if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
	// 	return (c / 2) * ((t -= 2) * t * t + 2) + b;
	// };
	$("a[href*='#']:not('.inline'), .scroll").click(function () {
		$("html, body").animate(
			{
				scrollTop: $($.attr(this, "href")).offset().top - 120, // - 70 等といれるとそのピクセル数分増えた状態でスクロールが止まる(ヘッダー固定の時に利用)
			},
			500
		);
		return false;
	});
};
/* ==========================================================
!Accordion
========================================================== */
const Accordion = function () {
	const accordion01 = $(".accordion dt");

	// クリックしたとき
	accordion01.on("click", function () {
		$(this).toggleClass("active").next().slideToggle();
	});

	// エンターキーを押したとき
	accordion01.on("keyup", function (e) {
		if (e.keyCode == 13) {
			$(this).toggleClass("active").next().slideToggle();
		}
	});

	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:767px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの


	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの


	}

	function matchFunction() {
		// (3)windowサイズを変更して、767px以下になったら発火するイベント


		if (window.matchMedia("(min-width:768px)").matches) {
			// (4)windowサイズを変更して、768px以上になったら発火するイベント


		}
	}
	window.matchMedia("(max-width:768px)").addListener(matchFunction);

};
/* ==========================================================
!tab
========================================================== */
const tabMenu = function () {
	$('.p-tabarea__tab').on('click',function(){
		const $tab = $('.p-tabarea__tab');
		const $tabpanel = $('.p-tabarea__tabpanel');
		const targetID = '#' + $(this).attr('aria-controls');
		$tab.attr('aria-selected',false).attr('aria-expanded',false);
		$(this).attr('aria-selected',true).attr('aria-expanded',true);
		$tabpanel.attr('aria-hidden',true);
		$(targetID).attr('aria-hidden',false);
	});
};
/* ==========================================================
!Scroll Animation
========================================================== */
const scrollAnimation = function () {
	const AnimTrigger = $(".effect"); //アニメーショントリガー
	const windowHeight = $(window).height(); //ウインドウの高さ

	// ロードした際に可視範囲に入っていたら実行される
	$(window).on("load", function () {
		AnimTrigger.each(function () {
			const imgPos = $(this).offset().top; //「AnimTrigger」の位置

			if (imgPos < windowHeight) {
				$(this).addClass("u-active");
			}
		});
	});

	// スクロールした際に「AnimTrigger」ごとに、以下に記述する内容が実行される
	$(window).scroll(function () {
		const scroll = $(window).scrollTop(); //スクロールした量

		AnimTrigger.each(function () {
			const imgPos = $(this).offset().top; //「AnimTrigger」の位置

			//アニメーションする条件＝「画面の下から1/5まできた時点でアニメーション」
			if (scroll > imgPos - windowHeight + windowHeight / 5) {
				//スクロール量　が次の条件より多いとき　…　条件：トリガーの場所　引く　ウィンドウの高さ　足す　ウィンドウの高さ　割る　5（- windowHeight + windowHeight / 5 なので6/5でなく4/5）
				$(this).addClass("u-active");
			}
		});
	});
};


/* ==========================================================
!Tel Link
========================================================== */
const telLink = function() {
	var ua = navigator.userAgent;
	if(ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0){
		$('.js-tel-link').each(function(){
			var str = $(this).text();
			$(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
		});
	}
}


/* ==========================================================
!Details Animation
========================================================== */
document.addEventListener("DOMContentLoaded", () => {
	setUpAccordion();
});

/**
 * ライブラリ(GSAP)を使ってアコーディオンのアニメーションを制御します
 */
const setUpAccordion = () => {
	const details = document.querySelectorAll(".js-details");
	const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

	details.forEach((element) => {
		const summary = element.querySelector(".js-details_summary");
		const content = element.querySelector(".js-details_body");

		summary.addEventListener("click", (event) => {
			// デフォルトの挙動を無効化
			event.preventDefault();

			// is-openedクラスの有無で判定（detailsのopen属性の判定だと、アニメーション完了を待つ必要がありタイミング的に不安定になるため）
			if (element.classList.contains(IS_OPENED_CLASS)) {
				// アコーディオンを閉じるときの処理
				// アイコン操作用クラスを切り替える(クラスを取り除く)
				element.classList.toggle(IS_OPENED_CLASS);

				// アニメーション実行
				closingAnim(content, element).restart();
			} else {
				// アコーディオンを開くときの処理
				// アイコン操作用クラスを切り替える(クラスを付与)
				element.classList.toggle(IS_OPENED_CLASS);

				// open属性を付与
				element.setAttribute("open", "true");

				// アニメーション実行
				openingAnim(content).restart();
			}
		});
	});
}

/**
 * アコーディオンを閉じる時のアニメーション
 */
const closingAnim = (content, element) => gsap.to(content, {
	height: 0,
	opacity: 0,
	duration: 0.4,
	ease: "power3.out",
	overwrite: true,
	onComplete: () => {
		// アニメーションの完了後にopen属性を取り除く
		element.removeAttribute("open");
	},
});

/**
 * アコーディオンを開く時のアニメーション
 */
const openingAnim = (content) => gsap.fromTo(
	content,
	{
		height: 0,
		opacity: 0,
	},
	{
		height: "auto",
		opacity: 1,
		duration: 0.4,
		ease: "power3.out",
		overwrite: true,
	});